import { apiClient } from './client'
import type { ModuleConfig } from '@/types/modules'

export const modulesApi = {
  refreshModuleConfig: async (): Promise<ModuleConfig> => {
    const response = await apiClient.get('/module-config/')
    return response.data
  },
}
